const ConfigApi = Object.freeze({
  MAX_INT32: 2147483647,
  MAINTENANCE_MODE: 0,
});

const typeCaptcha = Object.freeze({
  RE_CAPTCHA: 'recaptcha',
  H_CAPTCHA: 'hcaptcha',
  ALT_CAPTCHA: 'altcaptcha',
});

const modeEnum = Object.freeze({
  VERANO_JOVEN: 'verano-joven',
  ABONO_ANUAL: 'codigos',
});

export {ConfigApi, modeEnum, typeCaptcha};
